/* Import Modules */
import $ from "jquery";
import axios, { AxiosRequestConfig } from "axios";
import toastr from "toastr";

/* Import Variables */
import { isShow, driverLicenseTypesForPulldownByVue } from "../../variables";

/* Define Function */
const getAxiosOptions = () => {
  const axiosOptions: AxiosRequestConfig = {
    url: "/api/driving_license_type",
    method: "GET",
    params: {},
  };

  return axiosOptions;
};

export const getDrivingLicenseTypes = async () => {
  // Get Axios Option
  const axiosOptions = await getAxiosOptions();
  await axios(axiosOptions)
    .then((result) => {
      // Set CarModel
      let drivingLicenseTypeArray: Array<any> = [];
      drivingLicenseTypeArray.push({
        text: null,
        value: null,
      });
      $.each(result.data.data, function (index: any, value: any) {
        drivingLicenseTypeArray.push({
          text: value.name,
          value: value.id,
        });
      });
      driverLicenseTypesForPulldownByVue.driverLicenseTypes =
        drivingLicenseTypeArray;
    })
    .catch((error) => {
      console.log(error);
    });
};
